import React, { Component } from 'react';
import { 
  Modal, 
  Button, 
  Row, 
  Col, 
  Form, 
  FormGroup, 
  ControlLabel, 
  FormControl, 
  Alert 
} from 'react-bootstrap';

class BuySellModal extends Component {  
  constructor(props) {
    super(props);

    this.state = {
      amount: '',
      account: '',
      error: '',
      fileName: '',
      fileContent: ''
    };
  }

  // onFinish = (type) => {
  //   const { amount, account } = this.state;
  //   if (!amount || !account) {
  //     this.setState({ error: 'Please fill in all fields.' });
  //   } else {
  //     this.props.onBuySell({ type, account, amount });
  //     this.closeModal();
  //   }
  // }

  onBuy = () => {
    const { amount, account } = this.state;
    if (!amount || !account) {
      this.setState({ error: 'Please fill account and amount fields.' });
    } else {
      this.props.onBuySell({ 
        type: 'buy', 
        account, 
        amount, 
        activePortfolioId: this.props.activePortfolioId 
      });
      this.closeModal();
    }
  }

  onSell = () => {
    const { amount, account, fileName, fileContent } = this.state;
    if (!amount || !account || !fileName || !fileContent ) {
      this.setState({ error: 'Please fill all fields.' });
    } else {
      this.props.onBuySell({ 
        type: 'sell', 
        account, 
        amount, 
        fileContent, 
        activePortfolioId: this.props.activePortfolioId 
      });
      this.closeModal();
    }
  }

  fileOnChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      this.setState({ fileContent: reader.result });
    }
    this.setState({ fileName: file.name });
    reader.readAsText(file);
  }

  closeModal = () => {
    this.setState({ amount: '', account: '', error: '', fileName: '', fileContent: '' });
    this.props.closeModal('showBuySellModal');
  }

  renderAlert = () => {
    if (this.state.error) {
      return (
        <Alert bsStyle="danger">
          <strong>Oops!</strong> {this.state.error}
        </Alert>
      );
    }
  }

  render() {
    return (
      <Modal show={this.props.showBuySellModal} onHide={() => this.closeModal()} className="toolbar-modal">
        <Modal.Header closeButton>
          <Modal.Title>Buy / Sell</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col mdOffset={2} md={8}>
              <Form onSubmit={(e) => e.preventDefault()}>
                <FormGroup controlId="amount">
                  <ControlLabel>Enter Amount:</ControlLabel>
                  <FormControl 
                    type="number" 
                    placeholder="" 
                    value={this.state.amount} 
                    name="amount" 
                    onChange={(e) => this.setState({ [e.target.name]: e.target.value })} />
                </FormGroup>
                <FormGroup controlId="account">
                  <ControlLabel>Account Number:</ControlLabel>
                  <FormControl 
                    type="text" 
                    placeholder="" 
                    value={this.state.account} 
                    name="account" 
                    onChange={(e) => this.setState({ [e.target.name]: e.target.value })} />
                </FormGroup>
                <label>Sell using Schwab File:</label>
                <div className="input-group" style={{ marginBottom: 15 }}>
                  <label className="input-group-btn">
                    <span className="btn btn-success">
                        Browse
                        <input onChange={(e) => this.fileOnChange(e)} type="file" accept=".csv" name="file" style={{ display: 'none' }} />
                    </span>
                  </label>
                  <input type="text" className="form-control" value={this.state.fileName} readOnly />
                </div>
                {this.renderAlert()}
                <Button 
                  className="submit-right btn-blue" 
                  bsStyle="primary" 
                  onClick={() => this.onBuy()}
                >Buy</Button>
                <Button 
                  className="submit-left btn-blue"                                   
                  bsStyle="primary" 
                  onClick={() => this.onSell()}
                >Sell</Button>
              </Form>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button 
            bsStyle="default"  
            onClick={() => this.closeModal()}
          >Close</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default BuySellModal;